import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import {
  getClients,
} from '../../reducers/advisor';
import Client from './Client';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import s from './Clients.css';

library.add(faChevronLeft, faChevronRight, faCircleNotch);

class Clients extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      currPage: 0,
      numPerPage: 6,
    };
    this.paginate = this.paginate.bind(this);
  }

  paginate({selected}) {
    this.setState(Object.assign({}, this.state, {
      currPage: selected,
    }));
  }

  renderClients() {
    const {
      currPage,
      numPerPage,
    } = this.state;
    const {
      clients,
    } = this.props;

    if (clients && clients.length > 0) {
      const min = currPage * numPerPage;
      const max = min + numPerPage;
      const curClients = clients.slice(min, max);
      return (
        curClients.map((client) => {
          return (
            <Client key={client.id} client={client} />
          );
        })
      );
    } else if (!clients) {
      return (
        <div style={{textAlign:'center'}}><FontAwesomeIcon icon="circle-notch" size="lg" style={{ fontSize:'36px', marginTop:'20px', color: '#37BAC0' }} spin /></div>
      );
    } else {
      return (
        <div style={{textAlign:'center'}}>No clients to display</div>
      );
    }
  }

  render() {
    const {
      numPerPage
    } = this.state;
    const {
      clients,
    } = this.props;

    const pageCount = clients ? Math.ceil(clients.length / numPerPage) : 0;

    return (
      <div>
        <div className={'row'}>
          {this.renderClients()}
        </div>
        <div className={'row'}>
          <div className={'col-md-12'}>
            <ReactPaginate
              previousLabel={<FontAwesomeIcon icon="chevron-left" size="xs"/>}
              nextLabel={<FontAwesomeIcon icon="chevron-right" size="xs"/>}
              pageCount={pageCount}
              marginPagesDisplayed={pageCount}
              pageRangeDisplayed={pageCount}
              onPageChange={this.paginate}
              containerClassName={'pagination'}
              pageClassName={'page-item'}
              pageLinkClassName={s.pageLink}
              previousClassName={'page-item'}
              previousLinkClassName={s.pageLink}
              nextClassName={'page-item'}
              nextLinkClassName={s.pageLink}
              activeClassName={s.active}
              disabledClassName={s.disabled}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clients: getClients(state),
  };
}

export default connect(mapStateToProps, {
})(Clients);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/Clients.js